import { Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ActivationCenterResourceType } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter/enums'
import { UploadPayrollButton } from 'modules/finance/components/FinancialWorkspace/components/UploadPayroll'
import { REQUEST_SOURCE } from 'modules/finance/components/FinancialWorkspace/consts/requestSource'
import { NavigateToCompensation } from 'modules/finance/components/FinancialWorkspaceCompensations/components/NavigateToCompensation'
import { Availabilities } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/Availabilities'
import { FWPermissions } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/usePermissions'
import { FROM_AC_COMPONENT } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/lib/trackConst'
import { RequestInfoButton } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/components/Buttons/RequestInfo'

interface Props {
  availabilities: Availabilities
  permissions: FWPermissions
}

const SOURCE_ID = 'activation_center_payroll'

export const payrollResources = ({ availabilities, permissions }: Props) => {
  const button = availabilities.modules.compensations
    ? NavigateToCompensation()
    : UploadPayrollButton({
        type: 'outline',
        source: `${REQUEST_SOURCE} - ${FROM_AC_COMPONENT}_payroll`,
        textButton: i18n.t('finance.financial_workspace.activation_center.button.payroll'),
        includeButtonIcon: false,
      })

  const label = availabilities.modules.compensations
    ? i18n.t('finance.financial_workspace.activation_center.sources.compensation')
    : i18n.t('finance.financial_workspace.activation_center.sources.payroll')

  const resources = {
    filled: {
      label,
      type: ActivationCenterResourceType.FILLED,
      button,
      sourceId: SOURCE_ID,
    },
    missingData: {
      label,
      type: ActivationCenterResourceType.MISSING_DATA,
      button,
      sourceId: SOURCE_ID,
    },
    notEnabled: {
      label,
      type: ActivationCenterResourceType.NOT_ENABLED,
      button: RequestInfoButton({
        source: 'activation-center',
        buttonTexts: {
          requested: i18n.t(
            'finance.financial_workspace.activation_center.expenses.button.requested'
          ),
          unlock: i18n.t('upselling_kit.button.more_info'),
        },
        featureRequested: availabilities.modules.compensations
          ? Features.compensations_management
          : Features.payroll_management,
      }),
      sourceId: SOURCE_ID,
    },
  }

  const moduleAvailable = permissions.canSeeCompensations || permissions.canSeePayroll

  if (!moduleAvailable) return resources.notEnabled

  if (!availabilities.seePayrollLanding) return resources.filled

  return resources.missingData
}
